import auth from '@/modules/auth'
import menu from '@/modules/menu'
import ui from '@/modules/ui'
import assets from '@/modules/assets'
import conditions from '@/modules/conditions'
import departments from '@/modules/departments'
import acquisitions from '@/modules/acquisitions'
import entities from '@/modules/entities'
import movements from '@/modules/movements'
import external_employees from '@/modules/external_employees'
import utils from '@/modules/utils'

export default {
  conditions,
  departments,
  acquisitions,
  entities,
  assets,
  auth,
  menu,
  ui,
  movements,
  external_employees,
  utils,
}
